import { LockOutlined, UserOutlined, MailOutlined, SafetyCertificateOutlined } from "@ant-design/icons";
import { Button, message, Input, Select, Alert } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  SelectItem,
  InputNumberItem,
  InputItem,
  ErrorItem,
  SwitchItem,
  TransferItem,
} from "../../../../Components/Items";
import TextAreItem from "../../../../Components/TextAreaItem";
import PermisosUsuarioEditor from "../PermisosUsuarioEditor";
import LeyendaModulosLimitarProyectos from "../LeyendaModulosLimitarProyectos";
import TabbedDynamicTable from "../../../../Components/TabbedDynamicTable";

const { Option } = Select;

class AgregarUsuario extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    todasPerfiles: null,
    objetoPerfiles: null,
    todasProyectos: null,
    perfilIdSel: null,
    permisosUsuario: [],
  };
  componentDidMount() {
    axios.post("usuariosBiwo/selectCatalogosUsuarios", {}, { headers: this.props.headersToken }).then((res) => {
      if (res.data.success === 2) this.setState({ opcionesDepartamentos: res.data.departamentos.map((d) => ({ value: d.clave, label: d.nombre })) });
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }
  cerrarAgregarUsuario(codigo) {
    this.props.cerrarAgregarUsuario(codigo);
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "perfiles/selectPerfiles",
        { usuarioPrincipal: this.props.usuarioPrincipal },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasPerfiles: res.data,
            objetoPerfiles: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre + " - " + value.descripcion}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "proyectos/selectProyectosPEmpresa",
        { usuarioPrincipal: this.props.usuarioPrincipal },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({ todasProyectos: res.data });
        }
      });
    this.setState({ loading: false });
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onChangeValoresForm = (changed) => {
    if ("perfilId" in changed) {
      this.setState({ perfilIdSel: changed.perfilId });
    }
  };
  onFinish(values) {
    this.setState({ loading: true });
    if (values.password === values.confirmarcontraseña) {
      axios
        .post(
          "usuarios/agregarUsuario",
          {
            ...values,
            usuarioPrincipal: this.props.usuarioPrincipal,
            permisosUsuario: this.state.permisosUsuario,
          },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data?.success === 2) {
            message.success("Se ha agregado un usuario");
            this.formRef.current.resetFields();
            this.setState({ permisosUsuario: [], perfilIdSel: null });
            this.cerrarAgregarUsuario();
          } else if (res.data.nombre === 1) {
            message.error('El nombre ya existe');
          } else if (res.data.error) {
            message.error(res.data.error);
          } else {
            message.error('Ha sucedido un error y no se pudo agregar el usuario');
          }
        });
    } else {
      this.setState({ loading: false });
      message.error("Las contraseñas no coinciden");
    }
  }
  render() {
    const tabs = [
      {
        key: '1',
        label: 'General',
        forceRender: true,
        customContent: (
          <>
            <FormItem label="Perfil" name="perfilId" required>
              <SelectItem placeholder="Perfil">
                {this.state.objetoPerfiles}
              </SelectItem>
            </FormItem>
            <FormItem label="Nombre">
              <Input.Group compact>
                <FormItem name="nombre" noStyle pattern required max={200}>
                  <Input style={{ width: "33%" }} placeholder="Nombre" prefix={<UserOutlined className="site-form-item-icon" />} />
                </FormItem>
                <FormItem name="apellidoPaterno" noStyle pattern required max={200}>
                  <Input style={{ width: "33%" }} placeholder="Apellido P." />
                </FormItem>
                <FormItem name="apellidoMaterno" noStyle pattern required max={200}>
                  <Input style={{ width: "33%" }} placeholder="Apellido M." />
                </FormItem>
              </Input.Group>
            </FormItem>
            <FormItem name="nombreUsuario" label="Nombre Usuario" pattern required max={200} min={5}>
              <Input
                prefix={<UserOutlined className="site-form-item-icon" />}
                placeholder="Nombre de usuario"
              />
            </FormItem>
            <FormItem name="password" pattern required max={200} min={5} label="Contraseña">
              <Input.Password prefix={<LockOutlined className="site-form-item-icon" />} placeholder="Contraseña" />
            </FormItem>
            <FormItem name="confirmarcontraseña" pattern required max={200} min={5} label="Confirmar Contraseña">
              <Input.Password prefix={<LockOutlined className="site-form-item-icon" />} placeholder="Confirmar Contraseña" />
            </FormItem>
            <FormItem name="esVendedor" label="Vendedor" tooltip="Activar si el usuario es un vendedor." valuePropName="checked" initialValue={false}>
              <SwitchItem />
            </FormItem>
            <FormItem name="departamentos" label="Departamentos" initialValue={[]}>
              <SelectItem mode="multiple" placeholder="Departamentos del usuario" options={this.state.opcionesDepartamentos || []} />
            </FormItem>
          </>
        ),
      },
      {
        key: '5',
        label: 'Proyectos',
        forceRender: true,
        customContent: (
          <>
            <FormItem name="proyectos" valuePropName="targetKeys">
              <TransferItem
                dataSource={(this.state.todasProyectos || []).flatMap((empresa) =>
                  empresa.proyectos.map((proyecto) => ({
                    key: proyecto._id,
                    title: proyecto.nombre,
                    description: empresa.nombre,
                  }))
                )}
                filterOption={(inputValue, item) =>
                  item.title.toLowerCase().includes(inputValue.toLowerCase()) ||
                  item.description.toLowerCase().includes(inputValue.toLowerCase())
                }
                render={(item) => (item.description ? `${item.title} (${item.description})` : item.title)}
                titles={["Disponibles", "Asignados"]}
              />
            </FormItem>
            <FormItem
              name="limitarProyectos"
              label="Limitar acceso a proyectos"
              tooltip="Al activar esta opción, el usuario solo podrá ver los proyectos seleccionados arriba y no el resto de los proyectos de la empresa. Si se deja desactivado, podrá ver todos los proyectos de las empresas a las que tiene acceso."
              valuePropName="checked"
              initialValue={false}
            >
              <SwitchItem />
            </FormItem>
            <LeyendaModulosLimitarProyectos />
          </>
        ),
      },
      {
        key: '2',
        label: 'Avanzado',
        forceRender: true,
        customContent: (
          <>
            <FormItem label="Rfc" name="rfc" rfc margin>
              <InputItem placeholder="Registro Federal de Contribuyentes" />
            </FormItem>
            <FormItem label="Curp" name="curp" curp margin>
              <InputItem placeholder="Clave Unica de Registro de Poblacion" />
            </FormItem>
            <FormItem label="Celular" name="celular" number margin>
              <InputNumberItem placeholder="Celular" celular />
            </FormItem>
            <FormItem label="Telefono" name="telefono" number margin>
              <InputNumberItem placeholder="Telefono" celular />
            </FormItem>
            <FormItem label="Nss" name="nss" margin>
              <InputItem placeholder="Numero seguro social" />
            </FormItem>
            <FormItem label="Correo de Contacto" tooltip="Correo al que se enviarán los avisos del sistema" name="correoContacto" pattern required max={200} email>
              <InputItem prefix={<MailOutlined className="site-form-item-icon" />} placeholder="Correo" />
            </FormItem>
            <FormItem label="Observaciones" name="observaciones" margin pattern>
              <TextAreItem placeholder="Observaciones" />
            </FormItem>
          </>
        ),
      },
      {
        key: '4',
        label: 'Firma digital',
        customContent: (
          <Alert
            type="info"
            showIcon
            icon={<SafetyCertificateOutlined />}
            message="Firma digital no disponible al crear"
            description="Primero crea el usuario y después podrás agregar su firma digital desde la opción Editar."
            style={{ marginTop: 8 }}
          />
        ),
      },
      {
        key: '3',
        label: 'Permisos',
        forceRender: true,
        customContent: (
          <PermisosUsuarioEditor
            perfilId={this.state.perfilIdSel}
            overrides={this.state.permisosUsuario}
            onChange={(permisosUsuario) => this.setState({ permisosUsuario })}
          />
        ),
      },
    ];

    return (
      <>
        <ModalItem
          title="Agregar Usuario"
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarAgregarUsuario.bind(this)}
          paddingTop
        >
          <Form
            ref={this.formRef}
            name="agregarUsuario"
            layout
            onValuesChange={this.onChangeValoresForm}
            bottom={
              <Button
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Agregar
              </Button>
            }
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <TabbedDynamicTable
              tabs={tabs}
              defaultActiveKey="1"
            />
          </Form>
        </ModalItem>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    usuarioPrincipal: state.user.usuarioPrincipal,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(AgregarUsuario);
